import { Component, Input, OnInit } from '@angular/core';

/**
 * Responsive tile layout with optional maxColumns property (default 3).
 *
 * The minimum value for maxColumns is 1, anything lower will default to 1.
 * The maximum value for maxColumns is 4, anything higher will default to 4.
 */
@Component({
  selector: 'app-tile-layout',
  templateUrl: './tile-layout.component.html',
  styleUrls: ['./tile-layout.component.scss'],
  standalone: false,
})
export class TileLayoutComponent implements OnInit {
  @Input() maxColumns = 3;
  @Input() mobileThumbnails = false;
  @Input() isVertical = false;

  ngOnInit(): void {
    if (this.maxColumns < 1) this.maxColumns = 1;
    if (this.maxColumns > 6) this.maxColumns = 6;
  }
}
